import { consumeMagicLink } from 'requests/auth';
import { setSession } from 'services/auth';
import { notification, Spin } from 'antd';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const MagicLinkLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      window.location.replace('/login');
      return;
    }

    consumeMagicLink({ token })
      .then(async session => {
        await setSession(session);
        window.location.replace('/home');
      })
      .catch(() => {
        notification.error({
          message: 'Link inválido ou expirado',
          description: 'Solicite um novo Magic Link para continuar o acesso.'
        });
        window.location.replace('/login');
      });
  }, [token]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Spin size="large" />
    </div>
  );
};
